import axios from "axios";

// Function to get the access token from localStorage (or an authentication mechanism)
// -----------------TOKEN-----------------------
export const getAccessToken = () => {
  return localStorage.getItem("AccessTokenMMA");
};

export const setAccessToken = (token) => {
  if (token) {
    localStorage.setItem("AccessTokenMMA", token);
    return true;
  } else {
    return false;
  }
};

export const clearAccessToken = () => {
  localStorage.removeItem("AccessTokenMMA");
  
};

// --------------------BASEURL---------------------

let API_URL = "";
switch (process.env.REACT_APP_STATUS) {
  case "DEV":
    API_URL = process.env.REACT_APP_DEV_URL;
    
    break;
  case "STAGE":
    API_URL = process.env.REACT_APP_STAGE_URL;
    break;
    case "UAT":
    API_URL = process.env.REACT_APP_UAT_URL;
    break;

  case "PROD":
    API_URL = process.env.REACT_APP_PROD_URL;
    break;

  default:
    API_URL = process.env.REACT_APP_LOCAL_URL;
}

// Function to create an axios instance with the access token
const createAxiosInstance = () => {
  const token = getAccessToken();

  const axiosApi = axios.create({
    baseURL: API_URL,
  });

  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  axiosApi.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status !== 200) {
        let errorMessage = "Something went wrong, try again.";
        if (
          error.response.data &&
          (error.response.data.error?.message ||
            error.response.data?.message ||
            error.response.data?.error)
        ) {
          errorMessage =
            error.response.data.error?.message ||
            error.response.data?.message ||
            error.response.data?.error;
        } else {
          errorMessage =
            "Something went wrong. Report to Developer. Don't refresh the screen.";
        }

        if (
          error.response.status === 403 &&
          (errorMessage === "Invalid or expired accessToken." ||
            errorMessage === "No accessToken provided.")
        ) {
          localStorage.clear();
          window.location.reload();

          return Promise.reject(errorMessage);
        }

        return Promise.reject(errorMessage);
      }

      return Promise.reject(error);
    }
  );
  

  return axiosApi;
};

const rethrowIfCanceled = (error) => {
  if (axios.isCancel(error) || error?.code === "ERR_CANCELED") throw error;
  return error;
};

export async function get(url, config = {}) {
  const axiosApi = createAxiosInstance();
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response)
    .catch(rethrowIfCanceled);
}

export async function post(url, data, config = {}) {
  const axiosApi = createAxiosInstance();
  return await axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response)
    .catch(rethrowIfCanceled);
}

export async function put(url, data, config = {}) {
  const axiosApi = createAxiosInstance();
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response)
    .catch(rethrowIfCanceled);
}

export async function del(url, config = {}) {
  const axiosApi = createAxiosInstance();
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response)
    .catch(rethrowIfCanceled);
}

export async function postWithFile(url, data, config = {}) {
  const axiosApi = createAxiosInstance();
  return await axiosApi
    .post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getAccessToken()}`,
      },
    })
    .then((response) => response)
    .catch((error) => error);
}

export async function putWithFile(url, data, config = {}) {
  const axiosApi = createAxiosInstance();
  return await axiosApi
    .put(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getAccessToken()}`,
      },
    })
    .then((response) => response)
    .catch((error) => error);
}

// Download a backend-generated CSV export. Passes the JWT token,
// builds a query string from params, and triggers a browser download.
export async function downloadExport(path, params = {}, filename = 'export.csv') {
  const token = getAccessToken() || '';
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v != null && v !== '')).toString();
  const base = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
  const url = `${base}/${path}${qs ? '?' + qs : ''}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) throw new Error(`Export failed: ${res.status}`);
  const blob = await res.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export { API_URL };

